import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import OnboardingShell from './OnboardingShell';
import {
  DEFAULT_ONBOARDING_TONE,
  DEFAULT_ONBOARDING_TOPIC,
  ONBOARDING_TONES,
  ONBOARDING_TOPICS,
  saveOnboardingDraft,
  saveOnboardingStep,
} from './samples';

export default function TonePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const tone = DEFAULT_ONBOARDING_TONE;
  const topic = DEFAULT_ONBOARDING_TOPIC;

  useEffect(() => {
    saveOnboardingStep('/onboarding/tone', user?.id);
    saveOnboardingDraft({ tone, topic }, user?.id);
  }, [user?.id, tone, topic]);

  function continueNext() {
    saveOnboardingDraft({ tone, topic }, user?.id);
    navigate('/onboarding/preview');
  }

  return (
    <OnboardingShell title={t('onboarding.tone.title')}>
      <div className="mb-10">
        <div className="mb-3 text-xs font-semibold text-[#ff9a6c]">{t('onboarding.stepOf', { current: 1, total: 4 })}</div>
        <h2 className="m-0 text-[36px] font-extrabold tracking-[-0.02em]">{t('onboarding.tone.title')}</h2>
      </div>

      <div className="mb-8">
        <label className="mb-3 block text-sm font-semibold">{t('onboarding.tone.toneLabel')}</label>
        <div className="grid grid-cols-2 gap-3">
          {ONBOARDING_TONES.map((item) => {
            const selected = tone === item.id;
            return (
              <div
                key={item.id}
                aria-current={selected ? 'true' : undefined}
                className={`rounded-[10px] border-2 px-3 py-4 text-sm font-semibold ${
                  selected
                    ? 'border-[#ff6f91] bg-[#3a1a2a] text-[#f5eef7]'
                    : 'border-[#2b1f33] bg-[#221733] text-[#c9b8d1] opacity-60'
                }`}
              >
                {t(item.labelKey)}
              </div>
            );
          })}
        </div>
      </div>

      <div className="mb-8">
        <label className="mb-3 block text-sm font-semibold">{t('onboarding.tone.topicLabel')}</label>
        <div className="grid grid-cols-2 gap-3">
          {ONBOARDING_TOPICS.map((item) => {
            const selected = topic === item.id;
            return (
              <div
                key={item.id}
                aria-current={selected ? 'true' : undefined}
                className={`rounded-[10px] border-2 px-3 py-4 text-sm font-semibold ${
                  selected
                    ? 'border-[#b892ff] bg-[#2a1f3d] text-[#f5eef7]'
                    : 'border-[#2b1f33] bg-[#221733] text-[#c9b8d1] opacity-60'
                }`}
              >
                {t(item.labelKey)}
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex gap-3">
        <Link
          to="/onboarding"
          className="flex-1 rounded-lg border border-[#3d2e46] bg-transparent py-3 text-center text-sm font-semibold text-[#f5eef7]"
        >
          {t('onboarding.back')}
        </Link>
        <button
          type="button"
          onClick={continueNext}
          className="flex-1 rounded-lg border-none bg-[#ff6f91] py-3 text-sm font-semibold text-[#2b0e18] hover:bg-[#ff85a3]"
        >
          {t('onboarding.continue')}
        </button>
      </div>
    </OnboardingShell>
  );
}
